module.exports = {"231071002":"牡丹江经开区城乡街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231071.json
// module id = 876
// module chunks = 0